import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Modal from '../../../../components/Modal';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';

import { sendCancelNfse } from '../../store/thunk';
import { validations } from './validations';

export default function ProvisionalReceiptCancel({ open, receipt, page, pageSize, qp, extraProps, onClose }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishments } = useSelector(state => state.login);
  const { selects } = useSelector(state => state.filters);
  const { isCancelLoading } = useSelector(state => state.provisionalReceipt);

  const cancelNfseCodes = selects
    ?.find(filter => filter?.id == 'cancelNfseCodes')
    ?.options
    ?.map(option => {
      return {
        label: option?.cancelNfseCodeName || '--',
        value: option?.cancelNfseCodeId?.toString() || ''
      }
    }) || [];

  const getEstablishmentId = establishmentUuid => {
    const establishmentId = establishments
      ?.find(establishment => establishment?.uuid == establishmentUuid)
      ?.establishmentId;

    return establishmentId || '';
  }

  const handleCancelNfse = (values, { resetForm }) => {
    const params = {
      page,
      pageSize,
      qp,
      nfse: receipt?.nfse,
      nfce: receipt?.nfce,
      extraProps,
      code: values?.code,
      reason: values?.reason
    }

    dispatch(sendCancelNfse(userId, getEstablishmentId(receipt?.establishmentUuid), receipt?.uuid, params)).then(() => {
      resetForm();
      onClose();
    });
  }

  return(
    <Formik
      enableReinitialize
      validateOnChange={false}
      initialValues={{
        code: '',
        reason: ''
      }}
      validationSchema={validations}
      onSubmit={handleCancelNfse}
    >
      {({ values, errors, handleChange, handleSubmit, resetForm }) => (
        <Modal
          id="provisional-receipt-cancel"
          title="Cancelar Nota Fiscal"
          scroll="body"
          open={open}
          onClose={() => {
            resetForm();
            onClose();
          }}
          maxWidth="sm"
        >
          <Loader isLoading={isCancelLoading}>
            <Typography>
              O cancelamento de nota fiscal não pode ser revertido, têm certeza que deseja realizar essa situação?
            </Typography>
            <Grid container spacing={2} style={{ marginTop: 10 }}>
              <Grid item xs={12}>
                <Select
                  name="code"
                  label="Motivo do cancelamento"
                  options={cancelNfseCodes}
                  value={values.code}
                  error={errors.code}
                  helperText={errors.code}
                  onChange={handleChange}
                />
              </Grid>
              {(+values.code == 9) && (
                <Grid item xs={12}>
                  <Input
                    name="reason"
                    type="text"
                    label="Justificativa"
                    value={values.reason}
                    error={errors.reason}
                    helperText={errors.reason}
                    onChange={handleChange}
                  />
                </Grid>
              )}
            </Grid>
            <Grid container>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 10 }}>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  color="success"
                  onClick={handleSubmit}
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </Loader>
        </Modal>
      )}
    </Formik>
  );
}

ProvisionalReceiptCancel.propTypes = {
  open: PropTypes.bool.isRequired,
  receipt: PropTypes.object,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  qp: PropTypes.string,
  extraProps: PropTypes.object,
  onClose: PropTypes.func.isRequired
};